import React from 'react'
import PropTypes from 'prop-types'
import { connectHits } from 'react-instantsearch/connectors'
import { CustomerListItem } from './CustomerAccessories'
import { AddActionButton } from './CustomerAccessories'

class CustomerList extends React.PureComponent {

  static propTypes = {
    selectedCustomer: PropTypes.shape(),
    hits: PropTypes.array,
    onSelection: PropTypes.func,
    addCustomer: PropTypes.func
  }

  constructor(props){
    super(props)

    this.state = {
      results: [],
      selectedCustomer: props.selectedCustomer
    }
  }

  componentWillReceiveProps(nextProps){
    if (this.props.hits !== nextProps.hits){
      this.prepareResults(nextProps.hits)
    }
  }

  prepareResults = (hits) => {
    const results = []
    hits.forEach(hit => {
      if (hit.name){
        results.push(
          <CustomerListItem
            key={hit.objectID}
            id={hit.objectID}
            customerItem={hit}
            onCustomerSelected={this.onCustomerSelected}/>
        )
      }
    })
    this.setState({ results })
  }

  onCustomerSelected = (selectedCustomer) => {
    if (selectedCustomer){
      this.setState({ selectedCustomer })
    }
    this.props.onSelection(selectedCustomer)
  }

  render(){
    const addButtonLabel = 'Create a new customer'
    return (
      <div>
        { this.state.results }
        <AddActionButton label={addButtonLabel} onPress={this.props.addCustomer}/>
      </div>
    )
  }

}

export default connectHits(CustomerList)



// WEBPACK FOOTER //
// ./src/customer/CustomerList.js